import { Functions, HttpsCallable, httpsCallable } from 'firebase/functions'

export const DELETE_USER_SUCCESS_MESSAGE =
  'Usuario eliminado de Auth y Firestore.'

type DeleteUserCallable = HttpsCallable<{ uid: string }, unknown>

export const deleteUserThroughCallable = async (
  functionsInstance: Functions,
  userId: string,
  getCallable: typeof httpsCallable = httpsCallable,
) => {
  const deleteUserCompletely = getCallable(
    functionsInstance,
    'deleteUserCompletely',
  ) as DeleteUserCallable

  await deleteUserCompletely({ uid: userId })

  return DELETE_USER_SUCCESS_MESSAGE
}
